import Offers from "../../../pages/Offers";

const OffersRoot = Offers;

const offers = {
    basic: [
        {
          name: "Freelancer",
          id: "tier-freelancer",
          href: "#",
          price: "11 €",
          description: "RECIBE 250 CUP DE SALDO PRINCIPAL",
          mostPopular: false,
        },
        {
          name: "Startup",
          id: "tier-startup",
          href: "#",
          price: "16 €",
          description: "RECIBE 250 CUP DE SALDO PRINCIPAL",
      
          mostPopular: false,
        },
        {
          name: "Enterprise",
          id: "tier-enterprise",
          href: "#",
          price: "22 €",
          description: "RECIBE 250 CUP DE SALDO PRINCIPAL",
          mostPopular: false,
        },
        {
          name: "Enterprise",
          id: "tier-enterprise",
          href: "#",
          price: "26 €",
          description: "RECIBE 250 CUP DE SALDO PRINCIPAL",
          mostPopular: false,
        },
        {
          name: "Enterprise",
          id: "tier-enterprise",
          href: "#",
          price: "31 €",
          description: "RECIBE 250 CUP DE SALDO PRINCIPAL",
          mostPopular: false,
        },
        {
          name: "Enterprise",
          id: "tier-enterprise",
          href: "#",
          price: "35 €",
          description: "RECIBE 250 CUP DE SALDO PRINCIPAL",
          mostPopular: false,
        },
      ],
      specials:  [
        {
          name: "Freelancer",
          id: "tier-freelancer",
          href: "#",
          price: "22 €",
          description: "recarga 500 cup y recibe",
          features: [
            "1500 CUP de recarga",
            "5 GB en datos",
            "Internet ilimitado en la madrugada",
          ],
          mostPopular: false,
        },
        {
          name: "Startup",
          id: "tier-startup",
          href: "#",
          price: "35 €",
          description: "Triplica el saldo",
          features: [
            "2400 CUP de recarga",
            "5 GB en datos",
            "Internet Ilimitado en la madrugada",
          ],
          promo: {
              title: 'Oferta Limitada',
              description: 'Solo hasta el 8 de marzo'
          },
          mostPopular: true,
        },
        {
          name: "Enterprise",
          id: "tier-enterprise",
          href: "#",
          price: "16 €",
          description: "Recarga 350 CUP y recibe",
          features: [
            "1050 CUP de recarga",
            "5 GB de datos",
            "Internet ilimiatado en la madrugada",
          ],
          mostPopular: false,
        },
      ]
}
export const pricingLoader = async ()=> offers;
export default OffersRoot;
